import { render, staticRenderFns } from "./BannerList.vue?vue&type=template&id=0f6f64d4&scoped=true"
import script from "./BannerList.vue?vue&type=script&lang=ts"
export * from "./BannerList.vue?vue&type=script&lang=ts"
import style0 from "./BannerList.vue?vue&type=style&index=0&id=0f6f64d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f64d4",
  null
  
)

export default component.exports